import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Home from "./pages/Home";
import Experiences from "./pages/Experiences";
import Society from "./pages/Society";
import About from "./pages/About";
import Apply from "./pages/Apply";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Schedule from "./pages/Schedule";
import WellnessLog from "./pages/WellnessLog";
import MyProgram from "./pages/MyProgram";
import Alumni from "./pages/Alumni";
import Journal from "./pages/Journal";
import LegalPage, { LEGAL_DOCS } from "./pages/LegalPage";
import { BlogIndex, BlogPost } from "./pages/Blog";
import AdminBlog from "./pages/AdminBlog";
import { AdminApplications, AdminClients } from "./pages/Admin";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div style={{ minHeight: "100vh", background: "var(--charcoal)", color: "var(--gold-light)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "var(--serif)", letterSpacing: ".2em", textTransform: "uppercase", fontSize: ".8rem" }}>
        Softening…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/experiences" element={<Experiences />} />
            <Route path="/society" element={<Society />} />
            <Route path="/about" element={<About />} />
            <Route path="/apply" element={<Apply />} />
            {Object.keys(LEGAL_DOCS).map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<LegalPage slug={slug} />} />
            ))}
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/blog" element={<AdminBlog />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/portal" element={<Protected><Dashboard /></Protected>} />
            <Route path="/portal/schedule" element={<Protected><Schedule /></Protected>} />
            <Route path="/portal/log" element={<Protected><WellnessLog /></Protected>} />
            <Route path="/portal/journal" element={<Protected><Journal /></Protected>} />
            <Route path="/portal/program" element={<Protected><MyProgram /></Protected>} />
            <Route path="/portal/alumni" element={<Protected><Alumni /></Protected>} />
            <Route path="/admin" element={<Navigate to="/admin/applications" replace />} />
            <Route path="/admin/applications" element={<AdminApplications />} />
            <Route path="/admin/clients" element={<AdminClients />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
